import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useStyles from "@hooks/useStyles";
import withStyles from "@framework/src/libs/withStyles";
import styles from "../.styles";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
// import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useLoading from "@hooks/useLoading";
import Button from "@custom/Button";

const Footer = ({
	label,
	continueHandler,
	backHandler,
	skipHandler,
	message,
	btnType,
	formId,
	btnDisabled,
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

	return (
		<Box
			component={"div"}
			position={"fixed"}
			left={0}
			bottom={0}
			width={"100%"}
			bgcolor={"#FFF"}
			borderTop={1}
			borderColor={"#eee"}
			boxShadow={6}
			p={4}
		>
			{!isMobile && (
				<React.Fragment>
					<Container maxWidth={"md"}>
						<Box
							display={"flex"}
							position={"relative"}
							alignItems={"center"}
							justifyContent={"space-between"}
						>
							{backHandler ? (
								<Button
									onClick={backHandler}
									size={"large"}
									color="primary"
									startIcon={<ArrowBackIcon />}
								>
									Back
								</Button>
							) : (
								!message && <Box flexGrow={1} />
							)}
							{message && (
								<Box
									fontSize={12}
									lineHeight={1.5}
									mr={{ xs: 0, sm: 6 }}
									maxWidth={600}
								>
									{message}
								</Box>
							)}
							{skipHandler && (
								<Box sx={{ mr: 4 }}>
									<Button
										disableElevation
										onClick={skipHandler}
										size={"large"}
										variant={"outlined"}
									>
										Skip
									</Button>
								</Box>
							)}
							<Button
								onClick={continueHandler}
								disableElevation
								size={"large"}
								color="primary"
								variant={"contained"}
								type={btnType}
								form={formId}
								disabled={btnDisabled}
							>
								{label}
							</Button>
						</Box>
					</Container>
				</React.Fragment>
			)}

			{isMobile && (
				<React.Fragment>
					{message && (
						<Box fontSize={12} lineHeight={1.5} mb={4}>
							{message}
						</Box>
					)}
					<Box
						display={"flex"}
						position={"relative"}
						alignItems={"center"}
						justifyContent={"space-between"}
					>
						{skipHandler && !backHandler ? (
							<React.Fragment>
								<Box flexBasis={"48%"}>
									<Button
										fullWidth
										onClick={skipHandler}
										size={"large"}
										color="primary"
										variant={"outlined"}
									>
										Skip
									</Button>
								</Box>
								<Box flexBasis={"48%"}>
									<Button
										fullWidth
										onClick={continueHandler}
										disableElevation
										size={"large"}
										color="primary"
										variant={"contained"}
										type={btnType}
										form={formId}
									>
										{label}
									</Button>
								</Box>{" "}
							</React.Fragment>
						) : backHandler ? (
							<React.Fragment>
								<Box flexBasis={"48%"}>
									<Button
										fullWidth
										onClick={backHandler}
										size={"large"}
										color="primary"
										startIcon={<ArrowBackIcon />}
									>
										Back
									</Button>
								</Box>
								<Box flexBasis={"48%"}>
									<Button
										fullWidth
										onClick={continueHandler}
										disableElevation
										size={"large"}
										color="primary"
										variant={"contained"}
										type={btnType}
										form={formId}
									>
										{label}
									</Button>
								</Box>{" "}
							</React.Fragment>
						) : (
							<Box width={"100%"}>
								<Button
									fullWidth
									onClick={continueHandler}
									disableElevation
									size={"large"}
									color="primary"
									variant={"contained"}
									type={btnType}
									form={formId}
								>
									{label}
								</Button>
							</Box>
						)}
					</Box>
				</React.Fragment>
			)}
		</Box>
	);
};

Footer.defaultProps = {
	label: "Next",
	btnDisabled: false,
};

Footer.propTypes = {
	label: PropTypes.string,
	message: PropTypes.string,
	continueHandler: PropTypes.func.isRequired,
	backHandler: PropTypes.func,
	skipHandler: PropTypes.func,
	type: PropTypes.string,
	formId: PropTypes.string,
};

export default Footer;
